"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = __importStar(require("react"));
var withLabel_1 = require("../../InputLabel/withLabel");
var styles_1 = require("../Input/styles");
var SIZE_TO_STYLE = {
    small: react_1.css({
        height: 148,
        fontSize: 12,
        padding: '6px 12px',
    }),
    default: react_1.css({
        height: 148,
        fontSize: 14,
        padding: '7.5px 15px',
    }),
};
var TextArea = react_2.default.forwardRef(function (_a, ref) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, error = _a.error, value = _a.value, onChange = _a.onChange, textAreaProps = _a.textAreaProps, props = __rest(_a, ["size", "error", "value", "onChange", "textAreaProps"]);
    var theme = react_1.useTheme();
    var styles = react_2.useMemo(function () { return styles_1.createStyles(theme.name); }, [theme.name]);
    return (react_1.jsx("textarea", __assign({ ref: ref, css: [
            styles.input,
            styles.container,
            styles.placeholder,
            SIZE_TO_STYLE[size],
            error ? styles.errorContainer : undefined,
            props.disabled ? styles.disableContainer : undefined,
        ], value: value, onChange: function (e) { return onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value, e); } }, props, textAreaProps)));
});
exports.default = Object.assign(TextArea, {
    Labeled: withLabel_1.withLabel(TextArea),
});
